/**
 * Relative "time ago" label for a past ISO timestamp.
 *
 * Single shared implementation — do not duplicate per-page. Behavior:
 *   - missing/invalid input → '' (renders nothing)
 *   - under a minute → 'just now'
 *   - then `${m}m ago` / `${h}h ago` / `${d}d ago`
 */
export function timeAgo(dateStr?: string | null): string {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  if (Number.isNaN(diff)) return '';
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

export default timeAgo;
